(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.status = "idle";
        this.score = 0;
        this.initialState = initialState;
        this.state = initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(row) {
                    var newRow = _this.state[row].filter(function(value) {
                        return value !== 0;
                    });
                    for(var col = 0; col < newRow.length - 1; col++)if (newRow[col] === newRow[col + 1]) {
                        newRow[col] *= 2;
                        _this.score += newRow[col];
                        newRow.splice(col + 1, 1);
                        moved = true;
                    }
                    while(newRow.length < 4)newRow.push(0);
                    if (_this.state[row].join("") !== newRow.join("")) moved = true;
                    _this.state[row] = newRow;
                };
                if (this.status !== "playing") return;
                var moved = false;
                for(var row = 0; row < 4; row++)_loop(row);
                if (moved) {
                    this.addNewTile();
                    this.updateUI();
                    this.checkGameStatus();
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.status !== "playing") return;
                this.state = this.state.map(function(row) {
                    return row.reverse();
                });
                this.moveLeft();
                this.state = this.state.map(function(row) {
                    return row.reverse();
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.status !== "playing") return;
                this.state = this.transpose(this.state);
                this.moveLeft();
                this.state = this.transpose(this.state);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.status !== "playing") return;
                this.state = this.transpose(this.state).map(function(row) {
                    return row.reverse();
                });
                this.moveLeft();
                this.state = this.state.map(function(row) {
                    return row.reverse();
                });
                this.state = this.transpose(this.state);
            }
        },
        {
            key: "transpose",
            value: function transpose(matrix) {
                return matrix[0].map(function(_, colIndex) {
                    return matrix.map(function(row) {
                        return row[colIndex];
                    });
                });
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.score = 0;
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.addNewTile();
                this.addNewTile();
                this.updateUI();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.score = 0;
                this.status = "idle";
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.updateUI();
            }
        },
        {
            key: "addNewTile",
            value: function addNewTile() {
                var emptyCells = [];
                for(var r = 0; r < 4; r++){
                    for(var c = 0; c < 4; c++)if (this.state[r][c] === 0) emptyCells.push({
                        row: r,
                        col: c
                    });
                }
                if (emptyCells.length === 0) return;
                var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], row = _emptyCells_Math_floor.row, col = _emptyCells_Math_floor.col;
                this.state[row][col] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "updateUI",
            value: function updateUI() {
                var _this = this;
                var gameCells = document.querySelectorAll(".field-cell");
                gameCells.forEach(function(cell, index) {
                    var row = Math.floor(index / 4);
                    var col = index % 4;
                    var cellValue = _this.state[row][col];
                    cell.textContent = cellValue > 0 ? cellValue : "";
                    cell.className = "field-cell ".concat(cellValue > 0 ? "field-cell--".concat(cellValue) : "");
                });
                var gameScore = document.querySelector(".game-score");
                if (gameScore) gameScore.textContent = this.score;
                if (this.status === "win") document.querySelector(".message-win").classList.remove("hidden");
                else if (this.status === "lose") document.querySelector(".message-lose").classList.remove("hidden");
            }
        },
        {
            key: "checkGameStatus",
            value: function checkGameStatus() {
                if (this.checkWin()) this.status = "win";
                else if (this.checkLose()) this.status = "lose";
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                for(var rowIndex = 0; rowIndex < 4; rowIndex++)for(var colIndex = 0; colIndex < 4; colIndex++){
                    if (this.state[rowIndex][colIndex] === 2048) return true;
                }
                return false;
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    if (this.state[r][c] === 0) return false;
                    if (r > 0 && this.state[r][c] === this.state[r - 1][c]) return false;
                    if (r < 3 && this.state[r][c] === this.state[r + 1][c]) return false;
                    if (c > 0 && this.state[r][c] === this.state[r][c - 1]) return false;
                    if (c < 3 && this.state[r][c] === this.state[r][c + 1]) return false;
                }
                return true;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
$197cd56b15c33885$var$button.addEventListener("click", $197cd56b15c33885$var$activateGame);
function $197cd56b15c33885$var$activateGame() {
    $197cd56b15c33885$var$button.classList.toggle("restart");
    $197cd56b15c33885$var$button.classList.toggle("start");
    $197cd56b15c33885$var$messageStart.classList.toggle("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$gameScore.textContent = 0;
    if ($197cd56b15c33885$var$button.className.includes("start")) {
        $197cd56b15c33885$var$button.textContent = "Start";
        $197cd56b15c33885$var$game.restart();
    }
    if ($197cd56b15c33885$var$button.className.includes("restart")) {
        $197cd56b15c33885$var$button.textContent = "Restart";
        $197cd56b15c33885$var$game.start();
    }
    document.addEventListener("keydown", $197cd56b15c33885$var$handleKeydown);
}
//     if (this.status === 'idle'
//       || this.status === 'lose'
//       || this.status === 'win'
//     ) {
//       this.start();
//     } else {
//       this.restart();
//     }
//     this.updateUI();
//     document.querySelector('.message-win').classList.add('hidden');
//     document.querySelector('.message-lose').classList.add('hidden');
//   });
// }
function $197cd56b15c33885$var$handleKeydown(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
    }
    $197cd56b15c33885$var$game.updateUI();
    if ($197cd56b15c33885$var$game.getStatus() === "win") document.querySelector(".message-win").classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.getStatus() === "lose") document.querySelector(".message-lose").classList.remove("hidden");
}
$197cd56b15c33885$var$game.updateUI();

})();
//# sourceMappingURL=index.b28c03d5.js.map
